var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41536 2.0625C5.7468 2.0625 5.10561 2.32809 4.63287 2.80084C4.16012 3.27358 3.89453 3.91477 3.89453 4.58333V17.4167C3.89453 18.0852 4.16012 18.7264 4.63287 19.1992C5.10561 19.6719 5.7468 19.9375 6.41536 19.9375H15.582C16.2506 19.9375 16.8918 19.6719 17.3645 19.1992C17.8373 18.7264 18.1029 18.0852 18.1029 17.4167V7.304C18.1029 6.95475 17.9892 6.61558 17.7784 6.33692L15.0302 2.69958C14.8807 2.50169 14.6873 2.34117 14.4653 2.23062C14.2432 2.12008 13.9986 2.06253 13.7505 2.0625H6.41536ZM5.26953 4.58333C5.26953 3.95083 5.78286 3.4375 6.41536 3.4375H13.0612V7.46808C13.0612 7.84758 13.3692 8.15558 13.7487 8.15558H16.7279V17.4167C16.7279 18.0492 16.2145 18.5625 15.582 18.5625H6.41536C5.78286 18.5625 5.26953 18.0492 5.26953 17.4167V4.58333Z",
    fill: "#2C2C2C",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.f0c50bb964c43d8245fd7f06f85c0740.svg";
export { ForwardRef as ReactComponent };